// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6603":"70efa915","8908":"4f733fd0"}[chunkId] || chunkId) + "." + {"2321":"1d6ec5ee697a377a","3961":"43cc44d58bd1ca26","6149":"7d2b96c978dba924","6603":"9cc0a14ff1a5db05","7774":"708e84ab032284d3","8908":"34e70a977f9d5c28","9877":"7dac083fa28c15f6"}[chunkId] + ".js";
};